import React, { useMemo } from 'react'
import withSlideUpModal from '../../../../utils/hoc/withSlideUpModal'
import { sanitizeURLs } from '../../../../utils/helpers';
import DOMPurify from 'dompurify';

interface FeedbackProps {
    isActive: boolean,
    onClose: () => void
    feedback: string
}

const Feedback: React.FC<FeedbackProps> = ({ feedback, onClose }) => {
    return (
        <div>
            <div
                className={`content-wrapper feedback-content`}
            >
                <div
                    dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(sanitizeURLs(feedback)),
                    }}
                />
            </div>
            <div className="milestone-step-actions">
                <button onClick={onClose} className="btn btn-primary w-100">Continue</button>
            </div>
        </div>
    )
}


const FeedbackModal: React.FC<FeedbackProps> = (props) => {
    const title = `Feedback`

    const ModalComponent = useMemo(() => withSlideUpModal(Feedback, title), [title])
    return <ModalComponent {...props} />
}


export default FeedbackModal;